import styled from "styled-components";

import { MOBILE_BREAKPOINT } from "features/IikoIntegration/constants";

// Поле и кнопка в одной строке; на телефоне кнопка уезжает под поле на всю ширину.
export const Row = styled.div`
    display: flex;
    gap: 8px;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        flex-direction: column;
    }
`;

export const Field = styled.div`
    flex: 1 1 auto;
    min-width: 0;
`;

export const Action = styled.div`
    flex: 0 0 auto;
    display: flex;
    gap: 8px;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        button {
            flex: 1 1 auto;
        }
    }
`;
